import ManagerOperation from './ManagerOperation.container';

export default ManagerOperation;
